/** @format */
import { useTranslation } from 'next-i18next';

export const useRenderTooltipContent = (slug: string) => {
    const { t } = useTranslation();
    if (slug === 'low-shutter-count') {
        return t(
            "A low shutter count usually means it's been used less. This product has the lowest shutter count for its condition."
        );
    }
    return '';
};
